import m from "mithril"
import Navbar from "../../component/navbar"
import LeftMenu from "../../component/leftmenu"
import Footer from "../../component/footer"
import Validator from "validator"

var AddUser = {
    filename: '',
    oninit: function(vnode) {
        this.data = {
            name: "",
            address: "",
            phone: "",
            email: "",
            password: "",
            enablepos: false,
            active: false
        };
        this.error = {
            name: undefined,
            email: undefined,
            password: undefined,
            phone: undefined,
            address: undefined,
            active: false,
            enablepos: false
        };
    },
    view: function(vnode) {
        self = this;
        return m("div", [
          m("section", {class:"section"}, [
              m(Navbar)
          ]),
          m("section", {class:"section", style:"margin-top: -120px; "}, [
              m("div", {class:"columns"}, [
                  m("div", {class:"column is-one-fifth"}, [
                      m(LeftMenu, {title: "users"})
                  ]),
                  m("div", {class:"column"}, [
                      m("h1", {class:"title"}, "Add User"),
                      m("form",{
                        onsubmit: function(e) {
                        e.preventDefault()
                        //User.save()
                        console.log(self.data);
                        self.error.phone = !Validator.isLength(self.data.phone, {min:4, max: 100});
                        self.error.name = !Validator.isLength(self.data.name, {min:6, max: 100});
                        self.error.email = !Validator.isLength(self.data.email, {min:6, max: 100});
                        self.error.passsword = !Validator.isLength(self.data.password, {min:6, max: 40});
                        console.log(self.error);
                        if(!self.error.email && !self.error.password &&
                            !self.error.name)
                            {
                                m.request({
                                    method: "POST",
                                    url: "/api/users/insert",
                                    body: self.data
                                })
                                .then(function(data) {
                                    if(data.result)
                                    {
                                        location.href = '#!/users';
                                    }
                                    else
                                    {
                                        alert('insert outlet gagal');
                                    }
                                });
                            }
                    }},[

                        m("div", {class: "field"}, [
                            m("label", {class:"label"}, "Name"),
                            m("div", {class:"control has-icons-left"+((self.error.name) ? ' has-icons-right' : '')}, [
                                m("input", {class:"input"+((self.error.name) ? ' is-danger' : ''), type:"text", placeholder:"Name",
                                oninput: function(e){
                                    self.data.name = e.target.value;
                                }}),
                                m("span", {class: "icon is-small is-left"}, [
                                    m("i", {class:"fas fa-user"})
                                ]),
                                ((self.error.name) ?
                                          m("span", {class:"icon is-small is-right"}, [
                                              m("i", {class:"fas fa-exclamation-triangle"})
                                          ]) : "")
                            ]),
                            ((self.error.name) ? m("p", {class:"help is-danger"}, "This name is invalid") : "")
                        ]),
                        m("div", {class: "field"}, [
                            m("label", {class:"label"}, "Email"),
                            m("div", {class:"control has-icons-left"+((self.error.email) ? ' has-icons-right' : '')}, [
                                m("input", {class:"input"+((self.error.email) ? ' is-danger' : ''), type:"email", placeholder:"Email",
                                oninput: function(e){
                                    self.data.email = e.target.value;
                                }}),
                                m("span", {class: "icon is-small is-left"}, [
                                    m("i", {class:"fas fa-envelope"})
                                ]),
                                ((self.error.email) ?
                                          m("span", {class:"icon is-small is-right"}, [
                                              m("i", {class:"fas fa-exclamation-triangle"})
                                          ]) : "")
                            ]),
                            ((self.error.email) ? m("p", {class:"help is-danger"}, "This email is invalid") : "")
                        ]),
                        m("div", {class: "field"}, [
                            m("label", {class:"label"}, "Password"),
                            m("div", {class:"control has-icons-left"+((self.error.password) ? ' has-icons-right' : '')}, [
                                m("input", {class:"input"+((self.error.password) ? ' is-danger' : ''), type:"text", placeholder:"Password",
                                oninput: function(e){
                                    self.data.password = e.target.value;
                                }}),
                                m("span", {class: "icon is-small is-left"}, [
                                    m("i", {class:"fas fa-key"})
                                ]),
                                ((self.error.password) ?
                                          m("span", {class:"icon is-small is-right"}, [
                                              m("i", {class:"fas fa-exclamation-triangle"})
                                          ]) : "")
                            ]),
                            ((self.error.password) ? m("p", {class:"help is-danger"}, "This password is invalid") : "")
                        ]),
                        m("div", {class: "field"}, [
                            m("label", {class:"label"}, "Phone"),
                            m("div", {class:"control has-icons-left"+((self.error.phone) ? ' has-icons-right' : '')}, [
                                m("input", {class:"input"+((self.error.phone) ? ' is-danger' : ''), type:"text", placeholder:"Phone",
                                oninput: function(e){
                                    self.data.phone = e.target.value;
                                }}),
                                m("span", {class: "icon is-small is-left"}, [
                                    m("i", {class:"fas fa-phone"})
                                ]),
                                ((self.error.phone) ?
                                          m("span", {class:"icon is-small is-right"}, [
                                              m("i", {class:"fas fa-exclamation-triangle"})
                                          ]) : "")
                            ]),
                            ((self.error.phone) ? m("p", {class:"help is-danger"}, "This phone is invalid") : "")
                        ]),
                        m("div", {class:"field"}, [
                            m("label", {class:"label"}, "Address"),
                            m("div", {class:"control"}, [
                                m("textarea", {class:"textarea", placeholder:"Address",
                                oninput: function(e){
                                    self.data.address = e.target.value;
                                }})
                            ])
                        ]),
                        m("div", {class:"field"}, [
                            m("div", {class:"control"}, [
                                m("label", {class:"checkbox"}, [
                                    m("input", {type:"checkbox",
                                    onclick: function(e){
                                        self.data.active = e.target.checked;
                                    }}),
                                    " Active"
                                ])
                            ])
                        ]),
                        m("div", {class:"field"}, [
                            m("div", {class:"control"}, [
                                m("label", {class:"checkbox"}, [
                                    m("input", {type:"checkbox",
                                    onclick: function(e){
                                        self.data.enablepos = e.target.checked;
                                    }}),
                                    " Enable POS"
                                ])
                            ])
                        ]),
                        m("div", {class:"field is-grouped"}, [
                            m("div", {class:"control"}, [
                                m("button", {class:"button is-link"}, "Submit")
                            ]),
                            m("div", {class:"control"}, [
                                m("a", {class:"button is-text", href: "#!/users"}, "Cancel")
                            ])
                        ])

                    ])

                      
                  ])
              ])
          ]),
          m("section", {class:"section"}, [
              m(Footer)
          ])
        ]);
      }
}

module.exports = AddUser;